export default () => {
    return {
        // Technical fields
        packageVersion: process.env.VERSION || '0',
        softwareVersion: process.env.APP_VERSION || '0',
    }
}